

$(document).on("click", "#confirm_batch_status .batch_done", function() {
    showProcessing();
    let operation = $("#batch_status input[name=batch_status_change]:checked").val();
    let byIds = $("#batch_status input[name=batch_status_by_ids]:checked").val();
    $.ajax({
        type: "POST",
        url: batchroute+'/status',
        data: {'operation' : operation, 'byIds' : byIds},
        success: function () {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#confirm_batch_status').modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$(document).on("click", "#confirm_batch_republish .batch_done", function() {
    showProcessing();
    let byIds = $("#batch_republish input[name=batch_republish_by_ids]:checked").val();
    $.ajax({
        type: "POST",
        url: batchroute+'/republish',
        data: {'byIds' : byIds},
        success: function () {
            hideProcessing();
            $("#products").DataTable().draw(false);
            $("#confirm_batch_republish").modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$(document).on('typeahead:selected', '#batch_category #batch_category_add_category .typeahead', function (obj, datum) {
    // When a value is selected, set the selected datum on the typeahead field for later
    $('#batch_category #batch_category_add_categoryid').val(datum.data);
});

$(document).on('typeahead:selected', '#batch_category #batch_category_remove_category .typeahead', function (obj, datum) {
    // When a value is selected, set the selected datum on the typeahead field for later
    $('#batch_category #batch_category_remove_categoryid').val(datum.data);
});

$(function () {

    // Category Modal Typeahead
    $('#batch_category #batch_category_add_category .typeahead').typeahead({
        hint: true,
        highlight: true,
        minLength: 1
    },
    {
        limit: 50,
        name: 'selectaddcategory',
        displayKey: 'value',
        source: _.debounce(function (query, syncResults, asyncResults) {
            // Show spinner
            $('#batch_category #batch_category_add_category .input-spinner').addClass('input-spinner-processing');
            return $.get('/categories/ajax', {query: query}, function(data) {
                let results = [];
                $.each(data, function(index, value) {
                    results.push({value: value.fqn, data: value.id});
                });
                // Hide spinner
                $('#batch_category #batch_category_add_category .input-spinner').removeClass('input-spinner-processing');
                return asyncResults(results);
            });
        }, 500)
    });

    // Category Modal Typeahead
    $('#batch_category #batch_category_remove_category .typeahead').typeahead({
        hint: true,
        highlight: true,
        minLength: 1
    },
    {
        limit: 50,
        name: 'selectremovecategory',
        displayKey: 'value',
        source: _.debounce(function (query, syncResults, asyncResults) {
            // Show spinner
            $('#batch_category #batch_category_remove_category .input-spinner').addClass('input-spinner-processing');
            return $.get('/categories/ajax', {query: query}, function(data) {
                let results = [];
                $.each(data, function(index, value) {
                    results.push({value: value.fqn, data: value.id});
                });
                // Hide spinner
                $('#batch_category #batch_category_remove_category .input-spinner').removeClass('input-spinner-processing');
                return asyncResults(results);
            });
        }, 500)
    });

});

$(document).on("click", "#confirm_batch_sync .batch_done", function () {
    showProcessing();
    let channelId = $('#batch_channel_enable_channelid').val();
    let syncType = $('#batch_sync_sync_type').val();
    $.ajax({
        type: "POST",
        url: batchroute + '/sync',
        data: {
            'channelId': channelId,
            'syncType': syncType
        },
        success: function () {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#confirm_batch_sync').modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$(document).on("click", "#confirm_batch_category .batch_done", function() {
    showProcessing();
    let operation = $("#batch_category input[name=batch_category_operation]:checked").val();
    let category_id = $("#batch_category input#batch_category_"+operation+"_categoryid").val();
    let byIds = $("#batch_category input[name=batch_category_by_ids]:checked").val();

    $.ajax({
        type: "POST",
        url: batchroute+'/category',
        data: {
            'operation' : operation,
            'category_id' : category_id,
            'byIds' : byIds,
        },
        success: function () {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#confirm_batch_category').modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$(document).on("keyup", "#batch_category #batch_category_add_category .typeahead", function() {
    $("#batch_category [name=batch_category_operation][value=add]").prop("checked", "checked");
});
$(document).on("keyup", "#batch_category #batch_category_remove_category .typeahead", function() {
    $("#batch_category [name=batch_category_operation][value=remove]").prop("checked", "checked");
});

function showBatch_category() {
    // Reset the modal fields
    $('#batch_category #batch_category_add_category .typeahead').val('');
    $('#batch_category #batch_category_remove_category .typeahead').val('');
    $('#batch_category #batch_category_add_category .typeahead').typeahead('val', '');
    $('#batch_category #batch_category_remove_category .typeahead').typeahead('val', '');

    $('#batch_category #batch_category_add_category .typeahead').removeData('selected');
    $('#batch_category #batch_category_remove_category .typeahead').removeData('selected');

    $('#batch_category #batch_category_add_categoryid').val('');
    $('#batch_category #batch_category_remove_categoryid').val('');

    $("#batch_category [name=batch_category_operation]").removeProp("checked");
    $("#batch_category [name=batch_category_operation][value=add]").prop("checked", "checked");

    $("#batch_category").modal();
}

$(document).on("click", "#confirm_batch_channel .batch_done", function() {
    showProcessing();
    let operation = $("#batch_channel input[name=batch_channel_operation]:checked").val();
    let channel_id = $("#batch_channel select#batch_channel_"+operation+"_channelid").val();
    let byIds = $("#batch_channel input[name=batch_channel_by_ids]:checked").val();
    let withChildren = $("#batch_channel input[name=batch_channel_children]:checked").val();
    $.ajax({
        type: "POST",
        url: batchroute+'/channel',
        data: {
            'operation' : operation,
            'channel_id' : channel_id,
            'byIds' : byIds,
            'withChildren' : withChildren,
        },
        success: function () {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#confirm_batch_channel').modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$(document).on("click", "#confirm_batch_workflow .batch_done", function() {
    showProcessing();
    let workflow_state = $("#batch_workflow_state_workflow_state").val();
    let byIds = $("#batch_workflow_state input[name=batch_workflow_by_ids]:checked").val();
    $.ajax({
        type: "POST",
        url: batchroute+'/workflowstate',
        data: {
            'workflow_state' : workflow_state,
            'byIds' : byIds,
        },
        success: function () {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#confirm_batch_workflow').modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$("#batch_channel select#batch_channel_enable_channelid").on("change", function() {
    $("#batch_channel [name=batch_channel_operation][value=enable]").prop("checked", true);
});
$("#batch_channel select#batch_channel_disable_channelid").on("change", function() {
    $("#batch_channel [name=batch_channel_operation][value=disable]").prop("checked", true);
});

$(document).on("click", "#confirm_batch_attribute_set .batch_done", function() {
    showProcessing();
    let operation = $("#batch_attributeset input[name=batch_attributeset_operation]:checked").val();
    let attributeset_id = $("#batch_attributeset select#batch_attributeset_"+operation+"_attributesetid").val();
    let byIds = $("#batch_attributeset input[name=batch_attribute_set_by_ids]:checked").val();

    $.ajax({
        type: "POST",
        url: batchroute+'/attributeset',
        data: {
            'operation' : operation,
            'attributeset_id' : attributeset_id,
            'byIds' : byIds,
        },
        success: function () {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#confirm_batch_attribute_set').modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});
$("#batch_attributeset select#batch_attributeset_add_attributesetid").on("change", function() {
    $("#batch_attributeset [name=batch_attributeset_operation][value=add]").prop("checked", true);
});
$("#batch_attributeset select#batch_attributeset_remove_attributesetid").on("change", function() {
    $("#batch_attributeset [name=batch_attributeset_operation][value=remove]").prop("checked", true);
});

$(document).on("click", "#batch_attribute .batch_done", function() {
    showProcessing();
    let operation = $("#batch_attribute input[name=batch_attribute_operation]:checked").val();
    let attribute_id = $("#batch_attribute select#batch_attribute_"+operation+"_attributeid").val();
    let data = {
        'operation' : operation,
        'attribute_id' : attribute_id
    }

    if (operation == 'add') {
        let attribute_value = $("#batch_attribute input[name=batch_attribute_value]").val();
        if (attribute_value == '') {
            alert('You need to enter an attribute value!');
            return;
        }
        data.attribute_value = attribute_value;
    }

    $.ajax({
        type: "POST",
        url: batchroute+'/attribute',
        data: data,
        success: function () {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#batch_attribute').modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});
$("#batch_attribute select#batch_attribute_add_attributeid").on("change", function() {
    $("#batch_attribute [name=batch_attribute_operation][value=add]").radio("check");
});
$("#batch_attribute [name=batch_attribute_value]").on("keyup", function() {
    $("#batch_attribute [name=batch_attribute_operation][value=add]").radio("check");
});
$("#batch_attribute select#batch_attribute_remove_attributeid").on("change", function() {
    $("#batch_attribute [name=batch_attribute_operation][value=remove]").radio("check");
});

$(document).on("click", "#confirm_batch_tag .batch_done", function() {
    showProcessing();
    let operation = $("#batch_tag input[name=batch_tag_operation]:checked").val();
    let tag = $("#batch_tag input[name=batch_tag_"+operation+"tag]").val();
    let version = $("#batch_tag select[name=batch_tag_version]").val();
    let byIds = $("#batch_tag input[name=batch_tag_by_ids]:checked").val();

    $.ajax({
        type: "POST",
        url: batchroute+'/tag',
        data: {
            'operation' : operation,
            'tag' : tag,
            'version' : version,
            'byIds' : byIds,
        },
        success: function (data) {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#confirm_batch_tag').modal('hide');
            if(!data){
                showAjaxException();
            }
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$(document).on("click", "#header_new_product .new_product_create_header", function () {
    showProcessing();
    let name = $(".new_product_create_header_name").val();
    let bundle = 'off';
    if ($("#header_new_product #bundle").is(':checked')){
        bundle = 'on';
    }

    let error = false;
    if (name == '') {
        error = true;
        hideProcessing();
        $('#header_product_name').addClass('has-error');
    }

    if (!error) {
        $.ajax({
            type: "POST",
            url: window.location.origin + '/products/header/new',
            data: {
                'name': name,
                'bundle': bundle
            },
            dataType: "json",
            success: function (data) {
                window.location.href = data;
            },
            fail: function () {
                showAjaxException();
            }
        });
    }

});


$("#batch_tag [name=batch_tag_addtag]").on("keyup", function() {
    $("#batch_tag input[name=batch_tag_operation][value=add]").radio("check");
});
$("#batch_tag [name=batch_tag_removetag]").on("keyup", function() {
    $("#batch_tag input[name=batch_tag_operation][value=remove]").radio("check");
});

$(document).on("click", "#batch_shipping .batch_done", function() {
    showProcessing();
    let shipping_override = $("#batch_shipping_override").val();
    let shipping_price = $("#batch_shipping_price").val();


    $.ajax({
        type: "POST",
        url: batchroute+'/shipping',
        data: {
            'shipping_override' : shipping_override,
            'shipping_price' : shipping_price
        },
        success: function () {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#batch_shipping').modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$(document).on("click", "#confirm_batch_weight .batch_done", function() {
    showProcessing();
    let weight = $("#batch_weight_val").val();
    let height = $("#batch_height").val();
    let width = $("#batch_width").val();
    let prlength = $("#batch_length").val();
    let byIds = $("#batch_weight input[name=batch_weight_by_ids]:checked").val();

    $.ajax({
        type: "POST",
        url: batchroute+'/weight',
        data: {
            'weight' : weight,
            'height' : height,
            'width' : width,
            'length' : prlength,
            'byIds' : byIds,
        },
        success: function () {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#confirm_batch_weight').modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$(document).on("click", "#confirm_batch_price .batch_done", function() {
    showProcessing();
    let map = $("#batch_price .batch_map").val();
    let msrp = $("#batch_price .batch_msrp").val();
    let sell_price = $("#batch_price .batch_sell_price").val();
    let cost = $("#batch_price .batch_cost").val();
    let from = $("#batch_price .batch_start_date").val();
    let to = $("#batch_price .batch_end_date").val();
    let base = $("#batch_price .batch_base").val();

    $.ajax({
        type: "POST",
        url: batchroute+'/addprice',
        data: {
            'map' : map,
            'msrp' : msrp,
            'sell_price' : sell_price,
            'cost': cost,
            'from': from,
            'to': to,
            'base': base
        },
        success: function () {
            console.log('here');
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#confirm_batch_price').modal('hide');
        },
        fail: function () {
            console.log('here2');
            showAjaxException();
        }
    });
});

$(document).on("click", "#confirm_batch_search_and_replace_product_name .batch_done", function() {
    showProcessing();
    let search = $("#batch_search_and_replace_product_name .batch_product_search").val();
    let replace = $("#batch_search_and_replace_product_name .batch_product_replace").val();
    let action = $("#batch_search_and_replace_product_name .batch_product_action").val();
    let append = $("#batch_search_and_replace_product_name .batch_product_append").val();
    let byIds = $("#batch_search_and_replace_product_name input[name=batch_name_by_ids]:checked").val();
    $.ajax({
        type: "POST",
        url: batchroute+'/srname',
        data: {
            'search' : search,
            'replace' : replace,
            'action' : action,
            'append' : append,
            'byIds' : byIds,
        },
        success: function () {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#confirm_batch_search_and_replace_product_name').modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$(document).on("click", "#confirm_batch_description .batch_done", function() {
    showProcessing();
    let set = $("#batch_search_and_replace_description .batch_product_set").val();
    let search = $("#batch_search_and_replace_description .batch_product_search").val();
    let replace = $("#batch_search_and_replace_description .batch_product_replace").val();
    let append = $("#batch_search_and_replace_description .batch_product_append").val();
    let action = $("#batch_search_and_replace_description .batch_product_action").val();
    let byIds = $("#batch_search_and_replace_description input[name=batch_description_by_ids]:checked").val();

    $.ajax({
        type: "POST",
        url: batchroute+'/srdescription',
        data: {
            'set' : set,
            'search' : search,
            'replace' : replace,
            'action' : action,
            'append' : append,
            'byIds' : byIds
        },
        success: function () {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#confirm_batch_description').modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$(document).on("click", "#confirm_batch_warranty .batch_done", function() {
    showProcessing();
    let search = $("#batch_search_and_replace_warranty .batch_product_search").val();
    let replace = $("#batch_search_and_replace_warranty .batch_product_replace").val();
    let action = $("#batch_search_and_replace_warranty .batch_product_action").val();
    let append = $('#batch_search_and_replace_warranty .batch_product_append').val();
    let set = $('#batch_search_and_replace_warranty .batch_product_set').val();
    let byIds = $("#batch_search_and_replace_warranty input[name=batch_warranty_by_ids]:checked").val();

    $.ajax({
        type: "POST",
        url: batchroute+'/srwarranty',
        data: {
            'search' : search,
            'replace' : replace,
            'action' : action,
            'byIds' : byIds,
            'set' : set,
            'append' : append,
        },
        success: function () {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#confirm_batch_warranty').modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$(document).on("click", "#batch_search_and_replace_marketing .batch_done", function() {
    showProcessing();
    let search = $("#batch_search_and_replace_marketing .batch_product_search").val();
    let replace = $("#batch_search_and_replace_marketing .batch_product_replace").val();
    let action = $("#batch_search_and_replace_marketing .batch_product_action").val();

    $.ajax({
        type: "POST",
        url: batchroute+'/srmarketing',
        data: {
            'search' : search,
            'replace' : replace,
            'action' : action
        },
        success: function () {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#batch_search_and_replace_marketing').modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$(document).on("click", "#batch_specialorder .batch_done", function() {
    showProcessing();
    let special_order = $("#batch_specialorder input[name=batch_special_order]:checked").val();

    $.ajax({
        type: "POST",
        url: batchroute+'/specialorder',
        data: {
            'special_order' : special_order
        },
        success: function () {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#batch_specialorder').modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$(document).on("click", "#batch_project .batch_done", function() {

    let operation = $("#batch_project input[name=batch_project_operation]:checked").val();
    let data = {
        'operation' : operation,
    }

    if (operation == 'existing') {
        let projectid = $("#batch_project #batch_project_projectid").val();
        data.projectid = projectid;
    }
    else {
        let newprojectname = $("#batch_project input[name=batch_project_newname]").val();
        if (newprojectname == '') {
            alert('You need to enter a new project name!');
            return;
        }
        data.projectname = newprojectname;
    }
    showProcessing();
    $.ajax({
        type: "POST",
        url: batchroute+'/project',
        data: data,
        success: function (data) {
            hideProcessing();
            // Forward to new project id
            location.href='/projects/'+data.project_id+'/products';
        },
        fail: function () {
            hideProcessing();
            showAjaxException();
        }
    });
});
$("#batch_project [name=batch_project_newname]").on("keyup", function() {
    $("#batch_project input[name=batch_project_operation][value=new]").radio("check");
});
$("#batch_project select#batch_project_projectid").on("change", function() {
    $("#batch_project [name=batch_project_operation][value=existing]").radio("check");
});

$(document).on("click", "#batch_bundle .batch_done", function() {
    showProcessing();
    let operation = $("#batch_bundle input[name=batch_bundle_operation]:checked").val();
    let data = {
        'operation' : operation
    }

    if (operation == 'existing') {
        let bundleid = $("#batch_bundle #batch_bundle_bundleid").val();
        data.bundleid = bundleid;
    }
    else {
        let newbundlename = $("#batch_bundle input[name=batch_bundle_newname]").val();
        if (newbundlename == '') {
            alert('You need to enter a new bundle name!');
            return;
        }
        data.bundlename = newbundlename;
    }

    $.ajax({
        type: "POST",
        url: batchroute+'/bundle',
        data: data,
        success: function (data) {
            hideProcessing();
            // Forward to new bundle id
            location.href='/products/'+data.bundle_id+'/edit';
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$("#batch_bundle [name=batch_bundle_newname]").on("keyup", function() {
    $("#batch_bundle input[name=batch_bundle_operation][value=new]").radio("check");
});
$("#batch_bundle select#batch_bundle_bundleid").on("change", function() {
    $("#batch_bundle [name=batch_bundle_operation][value=existing]").radio("check");
});

$(document).on("click", "#batch_export .batch_done", function() {
    showProcessing();
    $(this).text("Processing..").prepend('<i class="fa fa-spinner fa-pulse fa-fw"></i> ');
    let profile = $("#batch_export select[name=batch_export_profile]").val();
    console.log(profile);
    $.ajax({
        url: batchroute + '/export',
        method: 'POST',
        data: {
            'profile': profile
        },
        success: function (data) {
            window.location.href="/exports";
        }
    });
});


$(document).on("click", "#batch_fastexport .batch_done", function() {
    showProcessing();
    $(this).text("Processing..").prepend('<i class="fa fa-spinner fa-pulse fa-fw"></i> ');
    $.ajax({
        url: '/products/fastexport',
        method: 'GET',
        xhrFields: {
            responseType: 'blob'
        },
        success: function (data) {
            $("#batch_fastexport .batch_done").text("Download");
            $("#batch_fastexport").modal('hide');
            hideProcessing();

            let download_link = document.createElement('a');
            download_link.setAttribute("type", "hidden");
            let url = window.URL.createObjectURL(data);
            download_link.href = url;
            let date = new Date().toLocaleString();
            download_link.download = 'PCS_Quick_Product_Export_' + date + '.csv';
            document.body.appendChild(download_link);
            download_link.click();

            setTimeout(function(){
                download_link.remove();
                window.URL.revokeObjectURL(url);
            }, 100);
        }
    });
});


$(document).on("click", "#batch_decal_add .batch_done", function() {

    showProcessing();
    let decal_id = $(".decals-select-add").val();
    let from = $(".decals-add-from").val();
    let to = $(".decals-add-to").val();
    $.ajax({
        type: "POST",
        url: batchroute+'/decaladd',
        data: {
            'decal_id' : decal_id,
            'from' : from,
            'to' : to
        },
        success: function () {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $(".decals-add-from").val("");
            $(".decals-add-to").val("");
            $('#batch_decal_add').modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$(document).on("click", "#batch_decal_remove .batch_done", function() {

    showProcessing();
    let decal_ids = $(".decals-select-remove").val();

    $.ajax({
        type: "POST",
        url: batchroute+'/decalremove',
        data: {
            'decal_ids' : decal_ids
        },
        success: function () {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#batch_decal_remove').modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$(document).on("change", "#batch_delete #batchDeleteConfirm", function() {
    if($(this).is(":checked")) {
        $('#batch_delete .batch_done').removeClass('disabled');
    } else {
        $('#batch_delete .batch_done').addClass('disabled');
    }
});

$(document).on("click", "#batch_delete .batch_done", function() {

    showProcessing();

    $.ajax({
        type: "POST",
        url: batchroute+'/delete',
        data: {},
        success: function () {
            hideProcessing();
            vm.$refs.prodlist.fetchProductList();
            $('#batch_delete').modal('hide');
        },
        fail: function () {
            showAjaxException();
        }
    });
});

$(document).on("click", "#batch_price #continue_price", function() {
    let mapInput = document.getElementById("map").value;
    let msrpInput = document.getElementById("msrp").value;
    let sellPriceInput = document.getElementById("sell_price").value;

    if (mapInput === "" && msrpInput === "" && sellPriceInput === "") {
        return window.confirm("If you don't enter at least ONE valid value for MAP, MSRP or Sell Price, the record will not be saved. Continue?");
    }
});
